import React, { useState } from "react";
import "../assets/styles/ProductReviews.css";

const ProductReviews = ({ productId, productName }) => {
  const [sortBy, setSortBy] = useState("latest");
  const [ratingFilter, setRatingFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [showWriteReview, setShowWriteReview] = useState(false);

  // Mock reviews data - in production, this would come from an API
  const [reviews] = useState([
    {
      id: 1,
      userName: "Israa A",
      isVerified: true,
      isPurchaseVerified: false,
      rating: 5,
      title: "Love it",
      content: "Neckline a bit too wide for me",
      productInfo: "Review for Baby Blue Leyla Blouse - M",
      wouldRecommend: true,
      date: "3 days ago",
      helpful: { up: 0, down: 0 },
    },
    {
      id: 2,
      userName: "Sivane G",
      isVerified: true,
      isPurchaseVerified: true,
      verifiedBy: "Jump",
      rating: 5,
      title: "Beautiful work on blouse!",
      content: "Beautiful work on blouse!",
      productInfo: "Review for Beige Zehna Handwork Blouse - S",
      wouldRecommend: true,
      date: "last month",
      helpful: { up: 0, down: 0 },
    },
    {
      id: 3,
      userName: "Priya M",
      isVerified: true,
      isPurchaseVerified: true,
      verifiedBy: "Jump",
      rating: 4,
      title: "Great quality fabric",
      content: "The fabric quality is amazing. Fits perfectly and the color is exactly as shown in the pictures.",
      productInfo: `Review for ${productName}`,
      wouldRecommend: true,
      date: "2 weeks ago",
      helpful: { up: 5, down: 0 },
    },
  ]);

  // Calculate average rating
  const averageRating = reviews.length > 0 
    ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(2)
    : 0;

  // Rating distribution
  const ratingDistribution = [5, 4, 3, 2, 1].map(star => ({
    star,
    count: reviews.filter(r => r.rating === star).length,
    percentage: reviews.length > 0 
      ? (reviews.filter(r => r.rating === star).length / reviews.length) * 100 
      : 0
  }));

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <span key={i} className={`star ${i < rating ? 'filled' : ''}`}>★</span>
    ));
  };

  const filteredReviews = reviews
    .filter(review => {
      if (ratingFilter !== "all" && review.rating !== parseInt(ratingFilter)) return false;
      if (searchQuery && !review.content.toLowerCase().includes(searchQuery.toLowerCase()) &&
          !review.title.toLowerCase().includes(searchQuery.toLowerCase())) return false;
      return true;
    })
    .sort((a, b) => {
      if (sortBy === "highest") return b.rating - a.rating;
      if (sortBy === "lowest") return a.rating - b.rating;
      return 0; // latest - keep original order
    });

  return (
    <div className="product-reviews-section">
      <div className="reviews-header">
        <h2 className="reviews-title">Worn & Adored.</h2>
      </div>

      <div className="reviews-summary">
        <div className="rating-overview">
          <div className="average-rating">
            <span className="rating-number">{averageRating}</span>
            <div className="rating-stars">{renderStars(Math.round(averageRating))}</div>
            <span className="review-count">{reviews.length} reviews</span>
          </div>
          <div className="rating-bars">
            {ratingDistribution.map(({ star, percentage }) => (
              <div key={star} className="rating-bar-row">
                <span className="bar-label">{star}</span>
                <div className="bar-track">
                  <div className="bar-fill" style={{ width: `${percentage}%` }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <button 
          className="write-review-btn"
          onClick={() => setShowWriteReview(true)}
        >
          WRITE A REVIEW
        </button>
      </div>

      <div className="reviews-filters">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <span className="search-icon">🔍</span>
        </div>
        
        <div className="filter-group">
          <label>Sort by:</label>
          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="latest">Latest</option>
            <option value="highest">Highest Rating</option>
            <option value="lowest">Lowest Rating</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Rating</label>
          <select value={ratingFilter} onChange={(e) => setRatingFilter(e.target.value)}>
            <option value="all">All</option>
            <option value="5">5 Stars</option>
            <option value="4">4 Stars</option>
            <option value="3">3 Stars</option>
            <option value="2">2 Stars</option>
            <option value="1">1 Star</option>
          </select>
        </div>

        <button className="photos-videos-btn">
          Photos & videos
        </button>
      </div>

      <div className="reviews-list">
        {filteredReviews.map((review) => (
          <div key={review.id} className="review-card">
            <div className="review-user-info">
              <div className="user-avatar">
                <span className="avatar-icon">👤</span>
                {review.isVerified && <span className="verified-badge">✓</span>}
              </div>
              <div className="user-details">
                <span className="user-name">{review.userName}</span>
                {review.isVerified && (
                  <span className="verified-text">
                    <span className="check-icon">✓</span> Verified buyer
                  </span>
                )}
                {review.isPurchaseVerified && (
                  <span className="purchase-verified">
                    <span className="check-icon">✓</span> Purchase verified by {review.verifiedBy}
                  </span>
                )}
              </div>
            </div>

            <div className="review-content">
              <div className="review-header">
                <div className="review-stars">{renderStars(review.rating)}</div>
                <span className="review-date">{review.date}</span>
              </div>
              <h4 className="review-title">{review.title}</h4>
              <p className="review-text">{review.content}</p>
              <p className="review-product-info">{review.productInfo}</p>
              
              {review.wouldRecommend && (
                <div className="would-recommend">
                  <span className="heart-icon">❤️</span> Would recommend
                </div>
              )}

              <div className="review-helpful">
                <span>Helpful</span>
                <button className="helpful-btn up">△</button>
                <button className="helpful-btn down">▽</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="see-more-container">
        <button className="see-more-btn">SEE MORE REVIEWS</button>
      </div>

      {/* Write Review Modal */}
      {showWriteReview && (
        <div className="review-modal-overlay" onClick={() => setShowWriteReview(false)}>
          <div className="review-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowWriteReview(false)}>×</button>
            <h3>Write a Review</h3>
            <form className="review-form">
              <div className="form-group">
                <label>Your Rating</label>
                <div className="star-input">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span key={star} className="star-select">★</span>
                  ))}
                </div>
              </div>
              <div className="form-group">
                <label>Review Title</label>
                <input type="text" placeholder="Give your review a title" />
              </div>
              <div className="form-group">
                <label>Your Review</label>
                <textarea placeholder="Write your review here..." rows="4"></textarea>
              </div>
              <div className="form-group checkbox">
                <input type="checkbox" id="recommend" />
                <label htmlFor="recommend">I would recommend this product</label>
              </div>
              <button type="submit" className="submit-review-btn">Submit Review</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductReviews;
